import jsPDF from "jspdf";
import logo from "./assets/logo.png";
import autoTable from "jspdf-autotable";

const fmt = (v) => (v == null ? "" : String(v));
const pad = (n) => {
  const x = String(n || "");
  return x.length === 1 ? `0${x}` : x;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fmt(value);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const formatMoney = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
};

const toNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};


export default function generateBolInvoicePdf({ bol, header, days, d_no , savedInvoiceAmount, savedReceiptAmount}) {
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 40;

  // Logo
  const logoWidth = 180;
  const logoHeight = 45;
  const logoX = (pageW - logoWidth) / 2;
  const logoY = 20;
  doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("AIR CARGO MANIFEST", margin, logoY + logoHeight + 30);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("I.C.A.O. Annex 9, Appendix 3", pageW - margin, logoY + logoHeight + 30, { align: "right" });
  
  doc.setLineWidth(1.5);
  doc.line(margin, logoY + logoHeight + 35, pageW - margin, logoY + logoHeight + 35);

  // Helper to get value regardless of case
  const getVal = (obj, key) => {
    if (!obj) return undefined;
    const camelKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    return obj[key] !== undefined ? obj[key] : obj[camelKey];
  };

  const departureDate = getVal(bol, "date_of_arrival") || getVal(header, "date_of_arrival") || new Date();
  const storageEndDate = getVal(bol, "storage_end_date") || getVal(bol, "storageEndDate") || departureDate;

  // Info Grid
  const infoStartY = logoY + logoHeight + 55;
  let infoCurrentY = infoStartY;
  const col1X = margin;
  const col2X = pageW / 2 + 50;
  const lineHeight = 14;

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Date prepared:", col1X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(formatDate(new Date()), col1X + 80, infoCurrentY);

  doc.setFont("helvetica", "bold");
  doc.text("Page:", col2X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text("01", col2X + 60, infoCurrentY);

  infoCurrentY += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Owner or Operator:", col1X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "owner_operator") || getVal(header, "owner_operator") || "TARCO AVIATION"), col1X + 100, infoCurrentY);

  doc.setFont("helvetica", "bold");
  doc.text("Prepared by:", col2X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(bol.prepared_by || "___________"), col2X + 80, infoCurrentY);

  infoCurrentY += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Registration:", col1X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "registration") || getVal(header, "registration") || "___________"), col1X + 80, infoCurrentY);

  doc.setFont("helvetica", "bold");
  doc.text("Manifest No:", col2X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "manifest_no") || getVal(header, "manifest_no") || bol.id || "___________"), col2X + 80, infoCurrentY);

  infoCurrentY += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Point of Loading:", col1X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "place_of_departure_code") || getVal(header, "place_of_departure_code") || "___________"), col1X + 100, infoCurrentY);

  doc.setFont("helvetica", "bold");
  doc.text("Customs Ref:", col2X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "customs_office_code") || getVal(header, "customs_office_code") || "___________"), col2X + 80, infoCurrentY);

  infoCurrentY += lineHeight;

  doc.setFont("helvetica", "bold");
  doc.text("Flight No:", col1X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "flight_no") || getVal(header, "flight_no") || getVal(bol, "voyage_number") || getVal(header, "voyage_number") || "___________"), col1X + 80, infoCurrentY);

  doc.setFont("helvetica", "bold");
  doc.text("Point of Unloading:", col2X, infoCurrentY);
  doc.setFont("helvetica", "normal");
  doc.text(fmt(getVal(bol, "place_of_destination_code") || getVal(header, "place_of_destination_code") || "___________"), col2X + 100, infoCurrentY);

  infoCurrentY += lineHeight;

  // ✅ إضافة تواريخ التخزين تحت Flight No مباشرة مع Bold
  const masterBolStorageStartDate = getVal(bol, "storage_start_date");
  const masterBolStorageEndDate = getVal(bol, "storage_end_date");

  doc.setFont("helvetica", "bold");
  doc.text(`Storage Start Date:`, col1X, infoCurrentY);
  doc.text(formatDate(masterBolStorageStartDate) || "—", col1X + 100, infoCurrentY);

  doc.text(`Storage End Date:`, col2X, infoCurrentY);
  doc.text(formatDate(masterBolStorageEndDate) || "—", col2X + 100, infoCurrentY);

  let currentY = infoCurrentY + lineHeight + 15;

// ✅ استخدام القيم المحفوظة بدلاً من إعادة الحساب لضمان دقة إعادة الطباعة
const getStorageFee = (b) => {
  // لو القيمة المحفوظة موجودة (في حالة إعادة الطباعة)، استخدمها مباشرة
  if (b === bol && savedInvoiceAmount !== undefined) {
    return toNumber(savedInvoiceAmount);
  }
  // fallback للقيمة المسجلة في سجل البوليصة
  if (b === bol && getVal(b, "invoice_amount") !== undefined) return toNumber(getVal(b, "invoice_amount"));
  const fee = b.storage_fee ?? b.storageFee;
  if (fee !== undefined && fee !== null) return toNumber(fee);
  // fallback
  return toNumber(b.fees?.storage ?? b.fees?.total ?? 0);
};

const getReceiptAmount = () => {
  return toNumber(savedReceiptAmount || bol.receipt_amount || bol.receiptAmount || 0);
};

const getBillableDays = (b) => {
  if (b === bol && days !== undefined) return days;
  const daysVal = b.billable_days ?? b.billableDays;
  if (daysVal !== undefined && daysVal !== null) return daysVal;
  return 0; // لا تحاول إعادة الحساب بدون freePeriods
};

  // دالة داخلية لتحويل التاريخ لنص YYYY-MM-DD بشكل آمن محلياً
  const parseToLocal = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };

  const calculateBolDays = (b, fbStart, fbEnd) => {
    const start = b.storage_start_date || b.storageStartDate || fbStart;
    const end = b.storage_end_date || b.storageEndDate || fbEnd || storageEndDate;
    if (!start || !end) return 0;

    const s = parseToLocal(start);
    const e = parseToLocal(end);
    
    // استخدام المنطق الحسابي "الفرق الفعلي" (Exclusive) ليطابق الشاشة
    let diff = Math.round((e - s) / (1000 * 60 * 60 * 24));
    
    // منطق خصم الساعات المجانية بناءً على نوع الشحنة
    const cargoType = b.cargo_type || b.cargoType || "GCR";
    if (cargoType === "GCR" || cargoType === "DG") {
      diff = Math.max(0, diff - 1);
    }

    if (b.day || b.subtract_day) diff = Math.max(0, diff - 1);
    return diff;
  };

  // حساب المجاميع من الكائن الممرر
  const totalPieces = Array.isArray(bol.homes) && bol.homes.length > 0 
    ? bol.homes.reduce((sum, h) => sum + toNumber(getVal(h, "number_of_packages")), 0)
    : toNumber(getVal(bol, "number_of_packages"));
    
  const totalWeight = toNumber(getVal(bol, "gross_mass"));
  
  // ✅ حساب المجموع الكلي للرسوم (ماستر + جميع الهاوسات)
  const masterFee = getStorageFee(bol);
  const housesFee = (bol.homes || []).reduce((sum, h) => sum + getStorageFee(h), 0);
  const finalTotalFee = masterFee + housesFee;

  const tableHeaders = [
      "Air Waybill",
      "Pieces",
      "Weight",
      "Nature of Goods",
      "Days",
      "Fee (USD)",
      "Official Use"
  ];

  const tableRows = [];

  // Add BULK row
  tableRows.push([{ content: "BULK CARGO", colSpan: 7, styles: { fillColor: [245, 245, 245], fontStyle: "bold" } }]);

  // Add master BOL row
  tableRows.push([
      fmt(getVal(bol, "bol_reference")),
      fmt(getVal(bol, "number_of_packages")),
      `${fmt(getVal(bol, "gross_mass"))} KG`,
      fmt(getVal(bol, "goods_description")),
      fmt(getBillableDays(bol)),
      formatMoney(getStorageFee(bol)),
      fmt(bol.official_use || "J EAP SPX.")
  ]);

  // Add homes BOLs if any
  if (Array.isArray(bol.homes)) {
    bol.homes.forEach(h => {
      tableRows.push([
        // ✅ تمييز بوالص الهاوس بإضافة سهم وإزاحة (Indentation)
        `    ↳ ${fmt(getVal(h, "bol_reference"))}`,
        fmt(getVal(h, "number_of_packages")),
        `${fmt(getVal(h, "gross_mass"))} KG`,
        fmt(getVal(h, "goods_description")),
        fmt(getBillableDays(h)),
        formatMoney(getStorageFee(h)),
        fmt(h.official_use || "J EAP SPX.")
      ]);
    });
  }

  autoTable(doc, {
    startY: currentY,
    head: [tableHeaders],
    body: tableRows,
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 5, textColor: [0, 0, 0], font: "helvetica" },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold", lineWidth: 0.5, lineColor: [0, 0, 0] },
    bodyStyles: { lineWidth: 0.5, lineColor: [0, 0, 0] },
    foot: [[
      "TOTAL",
      `${totalPieces} PCS`,
      `${totalWeight} KG`,
      { content: "", colSpan: 2 },
      formatMoney(finalTotalFee)
    ]],
    footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold", lineWidth: 0.5, lineColor: [0, 0, 0] },
  });

  // Storage Invoice Section (Optional title if needed)
  const finalY = doc.lastAutoTable.finalY + 30;
  doc.setFontSize(11);
  doc.text(`Invoice No: ${fmt(d_no || getVal(bol, "d_no"))}`, margin, finalY);

  doc.save(`Invoice_${fmt(bol.bol_reference || bol.bolReference)}.pdf`);
}
